import * as React from "react";
import HeaderBackButton from "../components/HeaderBackButton";
import { Container, Stack } from "@mui/joy";
import SendCoinItem from "../components/SendCoinItem";
import { useSelector } from "react-redux";

export default function Allcoins() {
  const walletData = useSelector((state) => state.walletsData);
  return (
    <>
      <HeaderBackButton title={"Send crypto"} />
      <Container maxWidth="md">
        <Stack spacing={3}>
          {walletData.map((coin, index) => (
            <SendCoinItem coin={coin} key={index} />
          ))}
        </Stack>
      </Container>
    </>
  );
}
